<template>
  <toast-manager/>
</template>

<script>
import ToastManager from '@/modules/toast/ToastManager';

export default {
  name: 'ToastWrapper',
  components: {
    ToastManager,
  },
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/spa/components/toast/ToastWrapper.vue